let DateTimeFormat = window.Intl && window.Intl.DateTimeFormat && window.Intl.DateTimeFormat();
let options = DateTimeFormat && DateTimeFormat.resolvedOptions && DateTimeFormat.resolvedOptions();
export const timeZone = (options && options.timeZone) || 'America/Los_Angeles';


